import axios from "axios"
import { api } from "../utils/api"
import AuthSession from "../utils/AuthSession"

const { company, user, token } = AuthSession

export const Login = async ( { dataLogin } ) => {
  try {
    const { data } = await axios.post( `${api}/auth/signin`, dataLogin )

    return data
  } catch ( error ) { }
}

export const signUp = async ( dataRegister ) => {
  try {
    const { data } = await axios.post(
      `${api}/auth/signup/${company}`,
      dataRegister
    )

    return data
  } catch ( error ) { }
}

export const validToken = async () => {
  try {
    // if ( !user || !company ) return false
    const { data } = await axios.get(
      `${api}/auth/validToken/${user}/${company}`,
      {
        headers: { Authorization: `${token}` },
      }
    )

    return data
  } catch ( error ) { }
}
